import moment from 'moment';
import { REPORT_TIME_FORMAT } from './constants';

export const getUTCOffset = (date = new Date()) => moment(date).utcOffset() * 60000;

export const formatReportDate = ms => moment(ms).format(REPORT_TIME_FORMAT);

export const formatDate = ms => moment(ms).format(REPORT_TIME_FORMAT);
